import React, { Component } from 'react'

class Sidebar extends Component {
        constructor () {
                super();
                this.state = {
                        mymenu: []
                };
        }


        componentDidMount () {
                axios.get('/api/mymenu').then(response => {
                        this.setState({
                              mymenu: response.data
                        });
                });
        }

        render() {
                return (
                <React.Fragment>
                    <button type="button" id="sidebarCollapse" className="btn btn-link text-white btn-icon">
                        <span>
                                <i className="material-icons md-18">menu</i><i className="material-icons md-18">arrow_back</i>
                        </span>
                        <h6 className="navbar-brand mb-0">シェアジョブ</h6>
                    </button>
                    <div id="dismiss">
                        <span></span>
                    </div>
                    <nav id="sidebar">
                        <div className="sidebar-header">
                        </div>

                        <ul className="list-unstyled components">
                                <li className="active">
                                        <a href="/houjin/home"><i className="material-icons">dashboard</i> ダッシュボード</a>
                                </li>
                                <li><a href="/houjin/jobs"><i className="material-icons">assignment</i> 依頼一覧</a></li>
                                <li><a href="/houjin/jobs/create"><i className="material-icons">edit</i> 依頼作成</a></li>
                                <li className="d-none d-sm-block"><a href="/houjin/jobapplys"><i className="material-icons">assignment_ind</i> 応募一覧</a></li>
                                <li><a href="/houjin/messages"><i className="material-icons">message</i> コメント履歴</a></li>
                        </ul>
                    </nav>
                </React.Fragment>
                );
        }
}

export default Sidebar
